import { Box, Stack, Typography } from '@mui/material';

import type { TelefonoContacto } from '../types';

interface TelefonosContactoDisplayProps {
  telefonos: TelefonoContacto[];
}

export function TelefonosContactoDisplay({
  telefonos,
}: TelefonosContactoDisplayProps): JSX.Element | null {
  if (telefonos.length === 0) return null;

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
        Teléfonos de contacto
      </Typography>
      <Stack spacing={0.5}>
        {telefonos.map((t, i) => (
          <Typography key={i} variant="body2">
            {t.nombre ? `${t.nombre} · ${t.numero}` : t.numero}
          </Typography>
        ))}
      </Stack>
    </Box>
  );
}
